import { useRef } from "react";

/**
 * 冻结产物播放地址 —— 轮询期间不让 `<video src>` 变。
 *
 * ═══ 为什么必须有这一层 ═════════════════════════════════════════════════════
 * 任务在途时详情页按 `pollIntervalMs`(RUNNING 5s / PENDING 1.5s)轮询,后端**每次都重新
 * presign**,同一个产物两次拿到的 URL 签名不同。`<video src>` 一变,浏览器当场丢掉已缓冲的
 * 数据重新加载 —— 用户看到的是「点了播放,播一秒就不动了」,而且任务越久越反复。
 *
 * ★ 2026-09-23 真机:详情页自己早有这套冻结(成片 + 单镜网格都走),唯独 `VideoChunkGrid`
 *   直接把 DTO 的 `videoUrl` 塞给播放器,于是**只有多镜分段卡片**会卡。同一份防护写在页面的
 *   闭包里、没人能复用,是它漏掉的直接原因 —— 所以这次把它抽成 hook,谁渲染产物谁调用。
 *
 * ★ key 必须带 `generatedAt`:重合成会**复用同一个 FINAL 资产 id**(只 generatedAt 变),
 *   只按 id 冻结的话,重合成之后播放器会一直放旧片(历史上的「重合成没反应」就是这条)。
 */
export function useFrozenAssetUrl() {
  const cache = useRef<Map<string, string>>(new Map());
  return (assetId: number, version: string | undefined, fresh?: string): string | undefined => {
    const key = `${assetId}:${version ?? ""}`;
    if (fresh && !cache.current.has(key)) cache.current.set(key, fresh);
    return cache.current.get(key) ?? fresh;
  };
}
